import { IAllergen, IClaims } from 'src/types/menu.types';

const joinUniqueNames = (values: { name: string }[] | undefined): string | null => {
  if (!Array.isArray(values) || values.length === 0) {
    return null;
  }

  return Array.from(new Set(values.map(({ name }) => name))).join(', ');
};

/**
 * Comma separated, de-duplicated allergen names, or null when there are none.
 */
export const getAllergens = (allergens: IAllergen[] | undefined): string | null => joinUniqueNames(allergens);

/**
 * Comma separated, de-duplicated claim names, or null when there are none.
 */
export const getClaims = (claims: IClaims[] | undefined): string | null => joinUniqueNames(claims);
